module.exports = __webpack_public_path__ + "static/img/Bachelor_010271.e2f9021.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010271.jpg
// module id = 134
// module chunks = 0